import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Problem } from "./components/sections/Problem";
import { Framework } from "./components/sections/Framework";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Challenges } from "./components/sections/Challenges";
import { Volumes } from "./components/sections/Volumes";
import { Bonuses } from "./components/sections/Bonuses";
import { ValueStack } from "./components/sections/ValueStack";
import { SpecialOffer } from "./components/sections/SpecialOffer";
import { Decision } from "./components/sections/Decision";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { FAQ } from "./components/sections/FAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-clip bg-white font-sans text-ink" data-id="element-0" data-mp="3ml14tc2x3ukl">
      <MetaPixel data-id="element-1" data-mp="3rc9hqi3ghy2i" />
      <Hero data-id="element-2" data-mp="3rbrcivytg9ig" />
      <main data-id="element-3" data-mp="3rdaq2et386gj">
        <Problem data-id="element-4" data-mp="3rdkl4gszp3t3" />
        <Framework data-id="element-5" data-mp="3rd189ei755lx" />
        <BeforeAfter data-id="element-6" data-mp="5yk6vxnnffx" />
        <Challenges data-id="element-7" data-mp="6hp9c27i9cj" />
        <Volumes data-id="element-8" data-mp="4ww9qvjiygs" />
        <Bonuses data-id="element-9" data-mp="5ggxfcks0yi" />
        <ValueStack data-id="element-10" data-mp="82j0zgp5o9c" />
        <SpecialOffer data-id="element-11" data-mp="2zld1d7i6tbah" />
        <Decision data-id="element-12" data-mp="2zlv7qwykd5w4" />
        <Testimonials data-id="element-13" data-mp="2zmenc70qri6z" />
        <Author data-id="element-14" data-mp="2zn6actg9w7ln" />
        <FAQ data-id="element-15" data-mp="33mouhn09senf" />
        <FinalCTA data-id="element-16" data-mp="33mf0loc3tncg" />
      </main>
      <Footer data-id="element-17" data-mp="33nq921ghvj9w" />
      <FloatingCTA data-id="element-18" data-mp="33n6xd2hftr4b" />
      <PurchasePopup data-id="element-19" data-mp="33orla998ybt7" />
    </div>;
}